import { cva } from 'class-variance-authority'

const variants = cva('flex gap-xxs rounded-lg p-xs w-full relative', {
  variants: {
    type: {
      neutral: '',
      error: '',
      warning: '',
      success: '',
    },
    style: {
      filled: '',
      bordered: 'border bg-transparent',
    },
  },
  compoundVariants: [
    {
      type: 'neutral',
      style: 'filled',
      class: 'bg-gray-100 text-gray-900',
    },
    {
      type: 'error',
      style: 'filled',
      class: 'bg-red-50 text-red-500',
    },
    {
      type: 'warning',
      style: 'filled',
      class: 'bg-yellow-50 text-yellow-600',
    },
    {
      type: 'success',
      style: 'filled',
      class: 'bg-green-50 text-green-500',
    },
    {
      type: 'neutral',
      style: 'bordered',
      class: 'border-gray-200 text-gray-900',
    },
    {
      type: 'error',
      style: 'bordered',
      class: 'border-red-200 text-red-500',
    },
    {
      type: 'warning',
      style: 'bordered',
      class: 'border-yellow-200 text-yellow-600',
    },
    {
      type: 'success',
      style: 'bordered',
      class: 'border-green-200 text-green-500',
    },
  ],
  defaultVariants: {
    type: 'neutral',
    style: 'filled',
  },
})

export default variants
